import { DeviceListComponent } from './components/DeviceListComponent';

export function DeviceList() {
    return <DeviceListComponent />;
}
